<template>
    <v-card
        :color="cardColor"
        class="document-card d-flex flex-column justify-center align-center"
        :class="{ 'cursor-pointer': clickable }"
        @click="emitClickOnClick && clickable && $emit('click')"
    >
        <div class="document-card-content d-flex flex-column justify-space-between text-center pa-2">
            <div class="document-card-title text-body-2 font-weight-medium">{{ title }}</div>
            <template v-if="subtitleDate && subtitleTime">
                <div class="document-card-subtitle document-card-subtitle-datetime text-caption">
                    <div>{{ subtitleDate }}</div>
                    <div>{{ subtitleTime }}</div>
                </div>
            </template>
            <v-tooltip v-else-if="subtitleTooltip" location="top">
                <template #activator="{ props }">
                    <div v-bind="props" class="document-card-subtitle text-caption">
                        {{ subtitle }}
                    </div>
                </template>
                {{ subtitleTooltip }}
            </v-tooltip>
            <div v-else class="document-card-subtitle text-caption">
                {{ subtitle }}
            </div>
            <div class="document-card-actions d-flex justify-space-around align-center" @click.stop>
                <slot name="actions" />
            </div>
        </div>
    </v-card>
</template>

<script>
export default {
    name: "ReservationDocumentCard",
    props: {
        title: { type: String, required: true },
        subtitle: { type: String, default: "" },
        /** When set with subtitleTime, shows date on one line and time on the other (for transport order / signed PDF). */
        subtitleDate: { type: String, default: null },
        /** When set with subtitleDate, shows time on second line. */
        subtitleTime: { type: String, default: null },
        /** When set, subtitle gets a tooltip on hover (e.g. full filename). */
        subtitleTooltip: { type: String, default: null },
        /** Vuetify color name. Ignored when `hasDocument` is true or false. */
        color: { type: String, default: null },
        /** When true → success, false → error (missing document). When unset, use `color`. */
        hasDocument: { type: Boolean, default: undefined },
        clickable: { type: Boolean, default: true },
        /** When true, emit 'click' on card click (for generate flow). When false, no emit (menu/tooltip handle click). */
        emitClickOnClick: { type: Boolean, default: false },
    },
    emits: ["click"],
    computed: {
        cardColor() {
            if (this.hasDocument === true) return "success";
            if (this.hasDocument === false) return "error";
            return this.color ?? "primary";
        },
    },
};
</script>

<style scoped>
.document-card {
    position: relative;
    width: 110px;
    height: 172px;
    overflow: hidden;
    transition: background-color 0.2s ease-in-out;
}

.document-card.cursor-pointer {
    cursor: pointer;
}

.document-card:not(.cursor-pointer) {
    cursor: default;
}

.document-card-content {
    width: 100%;
    flex: 1;
    min-height: 0;
}

.document-card-title {
    height: 3.4rem;
    line-height: 1.15;
    text-align: center;
    overflow: hidden;
}

.document-card-subtitle {
    min-height: 1.25em;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.document-card-subtitle-datetime {
    overflow: visible;
    text-overflow: unset;
    white-space: normal;
    min-height: 2.5em;
}

.document-card-actions {
    min-height: 32px;
}
</style>
